import { FormControl } from '@angular/forms';

import { IBasedForm } from './base-form';

export interface ILoginForm extends IBasedForm {
  agreementRegion: FormControl<boolean>;
  agreementRWT: FormControl<boolean>;
}
